import { useContext } from 'react';
import BrandContext from '../contexts/ListingType/components/BrandPage/components/BrandProvider/BrandContext';

export default () => {
    const brandConsumer = useContext(BrandContext);

    return [brandConsumer?.state];
};
